(() => {
    const initializeStarumiMobileMenu = () => {
        const source = document.querySelector('[data-starumi-mobile-menu-source]');
        const drawer = document.getElementById('navigation-mobile');
        const mount = drawer?.querySelector('[data-starumi-mobile-menu-mount]');

        if (!source || !drawer || !mount || mount.firstElementChild) return;

        mount.append(...source.childNodes);
        source.remove();
        drawer.classList.add('starumi-mobile-menu-mounted');

        const root = mount.querySelector('.starumi-mobile-menu-root');
        const utilities = root?.querySelector('[data-starumi-mobile-menu-utilities]');
        const currency = drawer.querySelector(':scope > .halo-sidebar-wrapper > .nav-currency-language');

        if (utilities && currency) utilities.append(currency);

        const activatePanel = (panelName) => {
            root.querySelectorAll('[data-starumi-mobile-panel]').forEach((button) => {
                button.classList.toggle('is-active', button.dataset.starumiMobilePanel === panelName);
            });
            root.querySelectorAll('[data-starumi-mobile-menu-panel]').forEach((panel) => {
                const isActive = panel.dataset.starumiMobileMenuPanel === panelName;
                panel.hidden = !isActive;
                panel.classList.toggle('is-active', isActive);
            });
        };

        document.addEventListener('click', (event) => {
            if (event.target.closest('.mobileMenu-toggle')) activatePanel('characters');

            const toolbarTrigger = event.target.closest('[data-starumi-mobile-menu-trigger]');
            if (!toolbarTrigger) return;

            event.preventDefault();
            activatePanel('characters');

            const headerToggle = document.querySelector('.header-mobile .mobileMenu-toggle, .header-mobile--wrapper .mobileMenu-toggle');
            if (headerToggle && !document.body.classList.contains('menu_open')) {
                headerToggle.click();
            } else {
                document.body.classList.add('menu_open');
            }
        }, true);

        const syncToolbarTrigger = () => {
            const isOpen = document.body.classList.contains('menu_open');
            document.querySelectorAll('[data-starumi-mobile-menu-trigger]').forEach((button) => {
                button.setAttribute('aria-expanded', String(isOpen));
            });
        };

        new MutationObserver(syncToolbarTrigger).observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
        syncToolbarTrigger();

        root?.addEventListener('click', (event) => {
            const panelButton = event.target.closest('[data-starumi-mobile-panel]');
            const closeButton = event.target.closest('[data-starumi-mobile-menu-close]');

            if (closeButton) {
                document.body.classList.remove('menu_open');
                return;
            }

            if (!panelButton) return;

            const panelName = panelButton.dataset.starumiMobilePanel;
            activatePanel(panelName);
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeStarumiMobileMenu, { once: true });
    } else {
        initializeStarumiMobileMenu();
    }
})();
